'use client'

import { useEffect } from 'react'

export default function NewRelicScript() {
  useEffect(() => {
    // Import and initialize New Relic Browser Agent
    // This runs on client-side only
    if (typeof window !== 'undefined') {
      import('@newrelic/browser-agent/loaders/browser-agent')
        .then(({ BrowserAgent }) => {
          const options = {
            init: {
              distributed_tracing: { enabled: true },
              privacy: { cookies_enabled: true },
              ajax: { deny_list: ['bam.nr-data.net'] }
            },
            info: {
              beacon: 'bam.nr-data.net',
              errorBeacon: 'bam.nr-data.net',
              licenseKey: process.env.NEXT_PUBLIC_NEWRELIC_LICENSE_KEY || '',
              applicationID: process.env.NEXT_PUBLIC_NEWRELIC_APPLICATION_ID || '',
              sa: 1
            },
            loader_config: {
              accountID: process.env.NEXT_PUBLIC_NEWRELIC_ACCOUNT_ID || '',
              trustKey: process.env.NEXT_PUBLIC_NEWRELIC_ACCOUNT_ID || '',
              agentID: process.env.NEXT_PUBLIC_NEWRELIC_APPLICATION_ID || '',
              licenseKey: process.env.NEXT_PUBLIC_NEWRELIC_LICENSE_KEY || '',
              applicationID: process.env.NEXT_PUBLIC_NEWRELIC_APPLICATION_ID || ''
            }
          }

          // Initialize Browser Agent
          new BrowserAgent(options)
          console.log('New Relic Browser Agent initialized')
        })
        .catch(err => {
          console.error('Failed to load New Relic Browser Agent:', err)
        })
    }
  }, [])

  return null
}
